import { useInView } from 'react-intersection-observer';

export const useFullyInView = () =>
  useInView({
    threshold: 1, // Fully in view
  });
